import axios from 'axios'
import config from '../config'
import { addAuthToken } from '../helper'

const CALENDARS_EVENTS_ENDPOINT = `${config.BASE_URL}/api/calendars/events`

const OUT_OF_OFFICE = 'out_of_office'

export const getCurrentEvents = (eventType) => {
  let url = `${CALENDARS_EVENTS_ENDPOINT}?datetime=${Date.now()}`
  if (eventType) {
    url += `&event_type=${eventType}`
  }
  return axios.request(addAuthToken({
    ...config.GET,
    url,
  }))
}

export const getCurrentOutOfOfficeEvents = () => getCurrentEvents(OUT_OF_OFFICE)

export const postEvent = (eventType, eventDetails) => {
  const url = CALENDARS_EVENTS_ENDPOINT
  return axios.request(addAuthToken({
    ...config.POST,
    url,
    data: {
      event_type: eventType,
      ...eventDetails,
    },
  }))
}

export const postOutOfOfficeEvent = (eventDetails) => postEvent(OUT_OF_OFFICE, eventDetails)

export const patchEvent = (eventId, eventDetails) => axios.request(addAuthToken({
  ...config.PATCH,
  url: `${CALENDARS_EVENTS_ENDPOINT}/${eventId}`,
  data: { ...eventDetails },
}))

export const deleteEvent = (eventId) => axios.request(addAuthToken({
  ...config.DELETE,
  url: `${CALENDARS_EVENTS_ENDPOINT}/${eventId}`,
}))
